import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OrderSummeryPageRoutingModule } from './order-summery-routing.module';

import { OrderSummeryPage } from './order-summery.page';
import { OrderAnimatedloadingComponent } from 'src/app/component/orderanimatedloading/orderanimatedloading.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from '../../core/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrderSummeryPageRoutingModule,
    TranslateModule,
    PipeModule
  ],
  declarations: [OrderSummeryPage, OrderAnimatedloadingComponent],
  exports: [OrderSummeryPage, OrderAnimatedloadingComponent]
})
export class OrderSummeryPageModule { }
